import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { PopupFormCreateProject } from '@bvt-organisms';
import { useMappTaskAnalyze } from '@bvt-features/mapp/taskAnalyze/hook/useMappTaskAnalyze';
import moment from 'moment';
import _ from 'lodash';

/**
 * @copyright PT Bhumi Varta Technology
 * @author Randa <m.randa@bvarta.com>
 * @author Renta <renta.yustika@bvarta.com>
 * @param {object} props
 * @param {object} props.errorMessage
 * @param {()=>void} props.onDismissError dismiss error
 * @param {()=>void} props.projectName
 * @param {()=>void} props.isLoading
 * @param {boolean} props.isFailed
 * @param {()=>void} props.onNext
 * @param {()=>void} props.onPrev
 * @param {number} props.lastStep
 * @param {bool} props.renameChecker
 */
export function SiproStepZero(props) {
  const {
    onNext,
    onPrev,
    onDismissError,
    errorMessage,
    projectName,
    isLoading,
    isFailed,
    lastStep,
    renameChecker,
  } = props;

  const TASK_ANALYZE = useMappTaskAnalyze();
  useEffect(() => {
    TASK_ANALYZE.getListTask({ limit: 100 });
  }, []);
  const created_at = _.find(
    TASK_ANALYZE.state.data,
    (v) => v.analyze_type?.includes('site_profiling')
  )?.created_at;

  return (
    <PopupFormCreateProject
      errorMessage={errorMessage}
      handlers={{
        handleCancel: onPrev,
        handleSubmit: onNext,
        handleFailed: onDismissError,
      }}
      isFailed={isFailed}
      isLoading={isLoading}
      lastStep={lastStep}
      lastUsed={created_at ? moment(created_at).fromNow() : '-'}
      projectName={projectName}
      renameChecker={renameChecker}
      show={true}
      type='Site Profiling'
    />
  );
}
SiproStepZero.propTypes = {
  data: PropTypes.any,
  errorMessage: PropTypes.any,
  isFailed: PropTypes.bool,
  isLoading: PropTypes.any,
  onDismissError: PropTypes.func,
  onNext: PropTypes.any,
  onPrev: PropTypes.any,
  projectName: PropTypes.any,
};
